export default "__VITE_ASSET__rc75BsYv__"